module.exports = __webpack_public_path__ + "img/16581285_L.e8885e92.png";